import { color, font, query } from '@design/templateFns';
import styled from 'styled-components';

export const Header = styled.h2`
  color: ${color('fg')};
  ${font('headline-xxs')};
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 24px;

  @media screen and (${query.atLeast('tablet')}) {
    ${font('headline-sm')};
  }
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`;

export const Wrapper = styled.div`
  margin: 0;
  margin-left: 100px;
  margin-right: 100px;

  @media screen and (${query.atLeast('desktop')}) {
    margin-left: 194px;
    margin-right: 194px;
  }
  @media (max-width: 600px) {
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export const HistoryTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  border-radius: 4px;
  border: 1px solid #d4d4d4;

  td {
    text-align: left;
    padding: 16px;
    vertical-align: middle !important;
    @media screen and (${query.atLeast('tablet')}) {
      padding: 20px;
    }
  }
  th {
    text-align: left;
    padding: 12px 20px;
    background-color: ${color('fg')};
    color: ${color('bg')};
  }
  tr:nth-child(even) {
    background-color: #f4f4f4;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

export const Text = styled.div`
  color: ${color('fg')};
  ${font('body-md-light')};
  font-weight: 400;
  font-size: 14px;
  padding-bottom: 0;
  margin: 0;
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 16px;
  }
`;

export const Label = styled.h5<{ $event?: boolean }>`
  color: ${color('fg')};
  ${font('body-md-light')};
  font-weight: 600;
  font-size: 14px;
  padding-bottom: 0;
  margin: 0;
  margin-top: ${({ $event }) => ($event == true ? '8px' : ' 0')};
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 16px;
  }
`;

export const SmallText = styled.div`
  color: ${color('gray5')};
  ${font('body-md-light')};
  font-weight: 400;
  font-size: 12px;
  margin-top: 8px;
`;

export const HistoryTableMobile = styled.table`
  border-collapse: separate;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  width: 100%;
  display: none;
  td {
    text-align: left;
    vertical-align: middle !important;
    padding: 16px;
    @media screen and (${query.atLeast('tablet')}) {
      padding: 20px;
    }
  }
  tr:nth-child(even) {
    background-color: #f6f6f4;
  }
  @media (max-width: 600px) {
    display: table;
  }
`;
